import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const AppThemePreset = definePreset(Aura, {
  semantic: {
     primary: {
      50: '#f0f9f6',      // lightest sage green
      100: '#dcf2e8',     // lighter sage green  
      200: '#b9e5d1',     // light sage green
      300: '#8dd5b5',     // sage green tint
      400: '#67c599',     // sage green shade
      500: '#439376',     // primary sage green (#439376)
      600: '#357a5e',     // dark sage green
      700: '#296147',     // deeper sage green
      800: '#1f4937',     // darkest sage green
      900: '#163327',     // near black green
      950: '#0c1a13',     // pure black green
    },
    
    
      secondary: {
      50: '#f8f9fa',      // lightest neutral
      100: '#e9ecef',     // lighter neutral
      200: '#dee2e6',     // light neutral  
      300: '#ced4da',     // neutral tint
      400: '#adb5bd',     // neutral shade
      500: '#6c757d',     // primary neutral
      600: '#495057',     // dark neutral
      700: '#343a40',     // deeper neutral
      800: '#212529',     // darkest neutral
      900: '#1a1d20',     // near black
      950: '#0d0f11',     // pure black
    },

  success: {
      50: '#f0f9f6',
      100: '#dcf2e8', 
      200: '#b9e5d1',
      300: '#8dd5b5',
      400: '#67c599',
      500: '#439376',
      600: '#357a5e',
      700: '#296147',
      800: '#1f4937',
      900: '#163327',
      950: '#0c1a13',
    },
      info: {
      50: '#f0fdfa',
      100: '#ccfbf1',
      200: '#99f6e4',
      300: '#5eead4',
      400: '#2dd4bf',
      500: '#14b8a6',
      600: '#0d9488',
      700: '#0f766e',
      800: '#115e59',
      900: '#134e4a',
      950: '#042f2e',
    },
 warning: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      950: '#451a03',
    },
      error: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      950: '#450a0a',
    },
 surface: {
      0: '#ffffff',
      50: '#f8f9fa',
      100: '#f1f3f4',
      200: '#e8eaed',
      300: '#dadce0',
      400: '#bdc1c6',
      500: '#9aa0a6',
      600: '#80868b',
      700: '#5f6368',
      800: '#3c4043',
      900: '#202124',
      950: '#111213',
    },
  }
});